/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Tej Singh",
  title_a: "Namaste World!",
  title_b: "I'm Tej",
  subTitle: emoji(
    "A passionate Full Stack Software Developer having experience building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1mPNeUIFYavOImmbCTx_wruR4nxmoJNTE/view",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/tejbaise",
  linkedin: "https://www.linkedin.com/in/tejbaise/",
  gmail: "tejbaise@gmail.com",
  gitlab: "https://gitlab.com/tejbaise",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK ENGINEER CURRENTLY EXPLORING THE REALMS OF TECHNOLOGY",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS"
    ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fas fa-code-branch"
    },
    {
      skillName: "Linux",
      fontAwesomeClassname: "fab fa-ubuntu"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Government Engineering College, Gandhinagar",
      logo: require("./assets/images/gecGLogo.png"),
      subHeader: "Bachelor of Engineering in Electronics & Communication",
      duration: "May 2014 - May 2018",
      desc: "Placement Coordinator and NrityaBeat Dance Club Co-Head",
      descBullets: [
        "Advanced Bike Safety - Bike Assist(Prototype)",
        "Advanced Combat Machine - The Sentinel(Prototype)",
        "Park-Bot - Vehicle Parking Assist(Prototype)",
      ]
    },
    {
      schoolName: "Army Public School",
      logo: require("./assets/images/armySchoolLogo.png"),
      subHeader: "Higher Secondary School",
      duration: "April 2013",
      desc: "Physics, Chemistry, Maths with Computer Science",
      descBullets: ["Cultural Coordinator"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full Stack Developer / Junior Software Engineer",
      company: "Incapsulate India Pvt. Ltd.",
      companylogo: require("./assets/images/incap.jpg"),
      date: "May 2019 – November 2020",
      desc: "My role here was to design, write, and style the front-end components that meet the requirements of our clients and fulfill our user stories. I also monitored support for the clients and took care of production deployments.",
      descBullets: [
        "Clients: US Govt., Sigma Phi Epsilon(SigEp)",
        "Tech Stack: Angular, React, React Native, JavaScript, ES6, TypeScript, SASS, Salesforce, Node.js"
      ]
    },
    {
      role: "Software Development Engineer - I",
      company: "Actonate IT Solutions Pvt. Ltd.",
      companylogo: require("./assets/images/acto.jpg"),
      date: "Nov 2020 – June 2021",
      desc: "My role here was to design and develop full-stack web applications. Developing microservices in NodeJS, handling Administration Panels, Frontend Web Portals and Developing ETL Pipelines for Data Analysis",
      descBullets: [
        "Clients: The TactTree, Dainik Bhaskar Corporation Ltd.",
        "Tech Stack: ReactJS, NextJS, NodeJS-Express, MySQL, AWS"
      ]
    },
    {
      role: "Software Engineer",
      company: "Kore.ai",
      companylogo: require("./assets/images/kore.jpg"),
      date: "June 2021 – Present",
      desc: "My role here was to develop highly scalable front-end components and developing APIs on NodeJS."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/dc311.jpg"),
      projectName: "311 Non Emergency Services",
      // projectDesc: "non-emergency 311 services request management software, developed using Salesforce, React, Angular, Node.js, React Native and Ionic that follows Agile Methodology.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://311.dc.gov/citizen/home"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/db.png"),
      projectName: "Dainik Bhaskar Record Keeper",
      // projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://records.bhaskar.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Testimonials from Colleagues 🏆 "),
  subtitle:
    "I believe real achievement in life is how you've made the people around you feel. So, here are some nice things that my co-workers have to say about me !",

  achievementsCards: [
    {
      title: "Suresh Babu Shamala",
      subtitle:
        `It was really great working with Tej. He is one of the best
        resources that I have ever worked with. I am impressed a lot with
        his thought process and through to detailed analysis.I am sure he has all it
        takes to make it big in the
        industry.`,
      image: require("./assets/images/sbs.jpeg"),
      footerLink: [
        {
          name: "Technical Architect | incapsulate",
          url: "https://in.linkedin.com/in/shamalasureshbabu"
        }
      ]
    },
    {
      title: "Swagat Talsania",
      subtitle:
        `It has been a wonderful journey so far. You have been one of the brightest people I have
        worked with. Your quick learning skills amazed me when you were new at incapsulate. You truly defined the meaning
        of your name in that sense. You have been a great asset to the team. I am sure you would do great wherever you go.`,
      image: require("./assets/images/st.jpeg"),
      footerLink: [
        {
          name: "Senior Delivery Manager | incapsulate",
          url: "https://in.linkedin.com/in/swagat-talsania"
        }
      ]
    },
    {
      title: "Suhel Sheikh",
      subtitle:
        `I always enjoyed working with Tej. Along with the great
        technical skills he has, the kind and good nature and always helping
        attitude is something I really admire. So, a genius with easy to go and
        friendly nature is rare to find. He carries great professional values like
        Accountability and Ownership, which I am sure will take him to great heights
        in his career.`,
      image: require("./assets/images/ss.jpeg"),
      footerLink: [
        {
          name: "Lead Quality Engineer | incapsulate",
          url: "https://in.linkedin.com/in/suhel-sheikh"
        }
      ]
    },
    {
      title: "Harsh Shah",
      subtitle:
        `It was a pleasure working with Tej. He was one of the resources
        who had great understanding of technology and the product which reflected very well
        in his work. He is an easily approachable person and always up for any challenges.`,
      image: require("./assets/images/hs.jpeg"),
      footerLink: [
        {
          name: "Lead Software Engineer | incapsulate",
          url: "https://in.linkedin.com/in/harsh1732"
        }
      ]
    },
    // {
    //   title: "",
    //   subtitle:
    //     ``,
    //   image: require("./assets/images/"),
    //   footerLink: [
    //     {
    //       name: " | incapsulate",
    //       url: ""
    //     }
    //   ]
    // },
    // {
    //   title: "",
    //   subtitle:
    //     ``,
    //   image: require("./assets/images/"),
    //   footerLink: [
    //     {
    //       name: " | incapsulate",
    //       url: ""
    //     }
    //   ]
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    // {
    //   url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
    //   title: "Why REACT is The Best?",
    //   description:
    //     "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    // }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I WOULD LOVE TO SHARE MY LIMITED KNOWLEDGE AND GROW ALONG WITH THE COMMUNITY 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "Work in progress...",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    // "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want to discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-9427323708",
  email_address: "tejbaise@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "tejbaise", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
